import download from "downloadjs" ;
import { locale } from "./locales";

export function createXls(data){
    let formData = new FormData();

    const blob = new Blob([JSON.stringify(data)], {type : 'application/json'});
    formData.append("data", blob, "data.json");

    return fetch("/api/utils/createXls", {
        method: "POST",
        credentials: 'include',
        body: formData
    }).then(function(response) {
        if(response.status === 401){
            throw("NOT_LOGGED") ;
        }
        return response.blob();
    }).then(function(blob) {
        download(blob, data.filename||"export.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }) ;
}

export function createPdf(template, tableName, tablePk, filename, lang){
    return fetch("/api/utils/createPdf", {
        method: "POST",
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Lang-Code': lang || locale.lang,
        },
        body: JSON.stringify({
            template, tableName, tablePk
        })
    }).then(function(response) {
        if(response.status === 401){
            throw ("NOT_LOGGED") ;
        }
        return response.blob();
    }).then(function(blob) {
        download(blob, filename+".pdf", "application/pdf");
    }) ;
}
